export default __webpack_public_path__ + "static/media/likedButtonPic.84991600.svg";